<template>
  <header id="header" class="header">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top">
      <div class="container">
        <a class="logo-wrap" href="/">
          <img src="../../../assets/logoa.png" alt="Divinorum">
        </a>

        <button
          v-if="!mobileMenuOpen"
          class="navbar-toggler"
          type="button"
          @click="toggleMenu"
          aria-controls="navbarContent"
          :aria-expanded="mobileMenuOpen.toString()"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div :class="['collapse', 'navbar-collapse', 'navback', { show: mobileMenuOpen }]" id="navbarContent">
          <MainMenu />
          <button
            v-if="mobileMenuOpen"
            class="navbar-toggler navbar-toggler-close open"
            type="button"
            @click="toggleMenu"
            aria-label="Close navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import MainMenu from './MainMenu';

export default {
  components: {
    MainMenu
  },
  data() {
    return {
      mobileMenuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  z-index: 1030;
}

.navbar {
  padding: 0.75rem 0;
  background-color: #fff;
}

.navbar .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-wrap {
  display: inline-flex;
  align-items: center;
  margin-right: 1.5rem;
}

.logo-wrap img {
  max-height: 120px;
  width: auto;
}

.navback {
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
}

.main-navigation {
  display: flex;
  align-items: center;
}

.main-navigation > ul {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.main-navigation > ul > li {
  padding: 0 14px;
}

.main-navigation > ul > li > a {
  display: inline-flex;
  align-items: center;
}

.navbar-toggler {
  border: 0;
  padding: 0.25rem 0.5rem;
}

@media (max-width: 991.98px) {
  .navbar-collapse {
    padding-top: 0.75rem;
  }

  .navbar-toggler {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .navbar-toggler-icon {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 2px;
    background-color: #333;
    transition: transform 0.25s ease, background-color 0.25s ease;
  }

  .navbar-toggler-icon::before,
  .navbar-toggler-icon::after {
    content: "";
    position: absolute;
    left: 0;
    width: 20px;
    height: 2px;
    background-color: #333;
    transition: transform 0.25s ease, opacity 0.25s ease;
  }

  .navbar-toggler-icon::before {
    top: -6px;
  }

  .navbar-toggler-icon::after {
    top: 6px;
  }

  .navbar-toggler.open .navbar-toggler-icon {
    background-color: transparent;
  }

  .navbar-toggler.open .navbar-toggler-icon::before {
    transform: translateY(6px) rotate(45deg);
  }

  .navbar-toggler.open .navbar-toggler-icon::after {
    transform: translateY(-6px) rotate(-45deg);
  }

  .navbar-toggler-close {
    margin: 16px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
  }

  .navbar-toggler-close .navbar-toggler-icon {
    width: 24px;
    height: 2px;
  }
}

@media (min-width: 1200px) {
  .navbar .container {
    justify-content: space-between;
  }

  .logo-wrap {
    margin-right: 0;
  }

  .navback {
    justify-content: flex-end;
  }
}
</style>